// 三大模块 API
const reviewTodayCount = '/api/new/review/today-count'
const reviewWords = '/api/new/review/words'
const reviewSubmit = '/api/new/review/submit'
const reviewMastery = '/api/new/review/mastery-distribution'
const reviewErrorBook = '/api/new/review/error-book'
const reviewToggleStar = '/api/new/review/toggle-star'
const reviewToggleMastered = '/api/new/review/toggle-mastered'
const reviewWordStar = '/api/new/review/word-star'

const sessionStart = '/api/new/session/start'
const sessionEnd = '/api/new/session/end'

const statsToday = '/api/new/stats/today'
const statsTrend = '/api/new/stats/trend'
const statsWeakWords = '/api/new/stats/weak-words'
const statsWeeklyReport = '/api/new/stats/weekly-report'
const statsCalendar = '/api/new/stats/calendar'
const statsTotal = '/api/new/stats/total'

const checkinDo = '/api/new/checkin/do'
const checkinStatus = '/api/new/checkin/status'
const checkinSupplement = '/api/new/checkin/supplement'
const checkinCalendar = '/api/new/checkin/calendar'
const checkinRanking = '/api/new/checkin/ranking'

const progressBookSync = '/api/new/progress/book-sync'

const achievementList = '/api/new/achievement/list'
const achievementMarkRead = '/api/new/achievement/mark-read'

const pointsAccount = '/api/new/points/account'
const pointsLog = '/api/new/points/log'

export default {
  reviewTodayCount,
  reviewWords,
  reviewSubmit,
  reviewMastery,
  reviewErrorBook,
  reviewToggleStar,
  reviewToggleMastered,
  reviewWordStar,
  sessionStart,
  sessionEnd,
  statsToday,
  statsTrend,
  statsWeakWords,
  statsWeeklyReport,
  statsCalendar,
  statsTotal,
  checkinDo,
  checkinStatus,
  checkinSupplement,
  checkinCalendar,
  checkinRanking,
  progressBookSync,
  achievementList,
  achievementMarkRead,
  pointsAccount,
  pointsLog
}



// WEBPACK FOOTER //
// ./src/utils/newModuleApi.js